import React from "react";
import { Carousel } from "react-responsive-carousel";
import Section from "../Section/Section";
import { Link } from "react-router-dom";
import { useMobileScreen } from "../../utils/useMedia";
import RepairIphoneModelLink from "../RepairIphoneModelLink/RepairIphoneModelLink";

function PageModelLinks(links) {
  const listOfModelIphoneSlide1 = links.slice(0, 7);
  const listOfModelIphoneSlide2 = links.slice(7, 14);
  const listOfModelIphoneSlide3 = links.slice(14, 21);
  const listOfModelIphoneSlide4 = links.slice(21, 28);
  const listOfModelIphoneSlide5 = links.slice(28);

  const isMobile = useMobileScreen();
  if (isMobile) {
    return (
      <Section className="repair-iphone__models-links-container">
        <div className="repair-iphone-mobile__models-links-content">
          <h2 className="repair-iphone-mobile__models-links-title">
            Больше детальной информации по каждой модели
          </h2>
          <Carousel
            autoPlay={false}
            infiniteLoop={true}
            swipeable={true}
            emulateTouch={true}
            showIndicators={true}
            stopOnHover={true}
            dynamicHeight={false}
            showThumbs={false}
            showStatus={false}
            showArrows={false}
          >
            <div className="repair-iphone-mobile__models-links-container">
              <ul className="repair-iphone-mobile__models-links-list">
                {listOfModelIphoneSlide1.map((link, i) => {
                  return (
                    <li
                      key={i}
                      className="repair-iphone-mobile__models-links-item"
                    >
                      <div className="repair-mb__links-mobile-icon"></div>
                      <Link
                        to={link.href}
                        className="repair-iphone-mobile__models-links-link"
                      >
                        {link.model}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="repair-iphone-mobile__models-links-container">
              <ul className="repair-iphone-mobile__models-links-list">
                {listOfModelIphoneSlide2.map((link, i) => {
                  return (
                    <li
                      key={i}
                      className="repair-iphone-mobile__models-links-item"
                    >
                      <div className="repair-mb__links-mobile-icon"></div>
                      <Link
                        to={link.href}
                        className="repair-iphone-mobile__models-links-link"
                      >
                        {link.model}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="repair-iphone-mobile__models-links-container">
              <ul className="repair-iphone-mobile__models-links-list">
                {listOfModelIphoneSlide3.map((link, i) => {
                  return (
                    <li
                      key={i}
                      className="repair-iphone-mobile__models-links-item"
                    >
                      <div className="repair-mb__links-mobile-icon"></div>
                      <Link
                        to={link.href}
                        className="repair-iphone-mobile__models-links-link"
                      >
                        {link.model}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="repair-iphone-mobile__models-links-container">
              <ul className="repair-iphone-mobile__models-links-list">
                {listOfModelIphoneSlide4.map((link, i) => {
                  return (
                    <li
                      key={i}
                      className="repair-iphone-mobile__models-links-item"
                    >
                      <div className="repair-mb__links-mobile-icon"></div>
                      <Link
                        to={link.href}
                        className="repair-iphone-mobile__models-links-link"
                      >
                        {link.model}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="repair-iphone-mobile__models-links-container">
              <ul className="repair-iphone-mobile__models-links-list">
                {listOfModelIphoneSlide5.map((link, i) => {
                  return (
                    <li
                      key={i}
                      className="repair-iphone-mobile__models-links-item"
                    >
                      <div className="repair-mb__links-mobile-icon"></div>
                      <Link
                        to={link.href}
                        className="repair-iphone-mobile__models-links-link"
                      >
                        {link.model}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </Carousel>
        </div>
      </Section>
    );
  }
  return (
    <RepairIphoneModelLink
      heading="Мы также производим замену:"
      links={links}
    />
  );
}

const RepairIphoneModelLinksForServiceMobile = ({ links }) => {
  return PageModelLinks(links);
};

export default RepairIphoneModelLinksForServiceMobile;
